import getOONGroupNameFromField from './getOONGroupNameFromField';

const validateOONGroupFields = (selected = []) => (
  selected.filter(getOONGroupNameFromField)
);

export default validateOONGroupFields;
